const assistant = {
  // Page titles and descriptions
  "causal-assistant-title": "Causal Assistant",
  "causal-assistant-description": "AI-powered causal inference support tool. Get appropriate analysis methods and result interpretation support just by answering questions.",

  // Tab navigation
  "causal-assistant-tab1": "Home",
  "causal-assistant-tab2": "Analysis",
  "causal-assistant-tab3": "History",

  // Welcome section
  "causal-assistant-welcome": "Welcome to Causal Assistant",
  "causal-assistant-welcome-desc": "AI supports your causal inference. Tell us what kind of analysis you would like to perform.",

  // Feature cards
  "causal-assistant-feature1-title": "Analysis Design by Questions",
  "causal-assistant-feature1-desc": "Input your research objectives and hypotheses in natural language, and we'll suggest appropriate causal inference methods.",
  "causal-assistant-feature1-action": "Start Analysis",

  "causal-assistant-feature2-title": "Automatic Graph Generation",
  "causal-assistant-feature2-desc": "Analyze data characteristics and automatically generate causal graphs with optimal algorithms.",
  "causal-assistant-feature2-action": "Generate Graph",

  "causal-assistant-feature3-title": "Result Interpretation Support",
  "causal-assistant-feature3-desc": "Explain analysis results clearly and propose practical application methods.",
  "causal-assistant-feature3-action": "Start Interpretation",

  // Getting started section
  "causal-assistant-getting-started": "Getting Started",
  "causal-assistant-step1": "1. Input Research Question",
  "causal-assistant-step1-desc": "Please input what causal relationships you want to investigate in natural language.",
  "causal-assistant-step2": "2. Upload Data",
  "causal-assistant-step2-desc": "Upload the data file to be used for analysis.",
  "causal-assistant-start-now": "Start Now",

  // Chat interface
  "causal-assistant-new-chat": "New Chat",
  "causal-assistant-chat-history": "Chat",
  "causal-assistant-welcome-title": "How can I help you?",
  "causal-assistant-welcome-description": "Feel free to ask questions about causal inference and analysis",
  "causal-assistant-message-placeholder": "Type your message...",
  "causal-assistant-input-help": "Ask anything about causal inference analysis and methods (Enter: send, Shift+Enter: new line)",
  
  // Dropdown menu
  "causal-assistant-rename": "Rename",
  "causal-assistant-delete": "Delete",
  
  // Loading states
  "causal-assistant-loading": "Loading...",
  "causal-assistant-history-error": "Failed to load history",
  "causal-assistant-no-history": "No chat history",
  "causal-assistant-generating": "Thinking...",
  "causal-assistant-analyzing": "Analyzing...",
  "causal-assistant-slow-tool-starting": "Starting analysis task...",
  "causal-assistant-analysis-tool-running": "Running analysis tool...",
  "causal-assistant-computing-wait": "Computing. Please wait a moment...",
  
  // Empty chat states
  "causal-assistant-empty-chat-title": "No messages",
  "causal-assistant-empty-chat-description": "This chat doesn't have any messages yet. Please send a question using the message input field below.",
  
  // Chat loading states
  "causal-assistant-loading-chat": "Loading chat...",
  "causal-assistant-loading-chat-description": "Fetching message history. Please wait a moment.",
  
  // Causal Asset selection
  "causal-assistant-causal-asset-loading": "Loading...",
  "causal-assistant-causal-asset-select": "Please select a causal asset",
  "causal-assistant-causal-asset-not-found": "No causal assets found",
  
  // Analysis results
  "causal-assistant-subgroup-analysis-results": "Stratified causal analysis results",
  
  // Message editing
  "causal-assistant-edit-message-placeholder": "Edit message...",
  "causal-assistant-cancel": "Cancel",
  "causal-assistant-send": "Send",
  "causal-assistant-copy": "Copy",
  
  // Toast messages
  "causal-assistant-toast-rename-success": "Chat renamed successfully",
  "causal-assistant-toast-delete-success": "Chat deleted successfully",
  "causal-assistant-toast-rename-error": "Failed to rename chat",
  "causal-assistant-toast-delete-error": "Failed to delete chat",
  "causal-assistant-toast-copy-success": "Message copied to clipboard",
  "causal-assistant-toast-copy-error": "Failed to copy message",

  "causal-assistant-task-error-description": "A background task failed. Please try running the analysis again.",

  // Robustness evaluation
  "causal-assistant-process-result": "Result",
  "causal-assistant-robustness-edge": "Edge",
  "causal-assistant-robustness-ate": "ATE",
  "causal-assistant-robustness-random-cause": "Random Common Cause",
  "causal-assistant-robustness-data-subset": "Data Subset",
  "causal-assistant-robustness-placebo": "Placebo Treatment",
  "causal-assistant-robustness-result-col": "Result",

  // Auto update (autonomous model improvement)
  "causal-assistant-auto-update-result-title": "Autonomous Model Improvement Results",
  "causal-assistant-auto-update-before": "Before",
  "causal-assistant-auto-update-after": "After",

  // Mode
  "causal-assistant-mode-name1": "Expert Mode",
  "causal-assistant-mode-name2": "User Mode (Restricted)",
  "causal-assistant-mode-name1-request": "Expert Mode (Request)",

  // Request Modal
  "causal-assistant-request-modal-title": "Request use Expert Mode",
  "causal-assistant-request-modal-desc": "Would you like to send a request to the administrator to enable Expert Mode?",
  "causal-assistant-request-modal-button": "Send",
  "causal-assistant-request-modal-toast-success": "Send successfully.",
  "causal-assistant-request-modal-toast-error": "Send failed.",

  // File upload
  "causal-assistant-attach-file": "Attach file",
  "causal-assistant-remove-file": "Remove",
  "causal-assistant-drop-file": "Drop file here",

  // Candidate sets display
  "causal-assistant-candidate-show-more": "Show more +{{n}}",
  "causal-assistant-candidate-show-less": "Show less",

  // HITL (Human-in-the-loop)
  "causal-assistant-hitl-title": "Confirm graph change",
  "causal-assistant-hitl-approve": "Approve and run",
  "causal-assistant-hitl-reject": "Reject",
  "causal-assistant-hitl-reject-confirm": "Confirm rejection",
  "causal-assistant-hitl-reject-placeholder": "Reason for rejection (optional)",
  "causal-assistant-hitl-resuming": "Processing your decision...",
  "causal-assistant-hitl-processing": "Processing...",
  "causal-assistant-hitl-input-disabled": "A tool is awaiting approval. Approve or reject using the confirmation above.",
  "causal-assistant-hitl-toast-error": "Failed to process approval. Please try again.",

  // Artifact viewer
  "causal-assistant-artifacts-title": "Artifacts",
  "causal-assistant-artifacts-error": "Failed to load",
  "causal-assistant-artifacts-close": "Close",

  // Menu (log download)
  "causal-assistant-menu": "Menu",
  "causal-assistant-menu-log-download": "Download Logs",
  "causal-assistant-log-download-success": "Logs downloaded",
  "causal-assistant-log-download-error": "Failed to download logs",

  // Used by the main-version assistant (_legacy)
  "causal-assistant-task-completed-description": "The task has been completed.",
  "causal-assistant-show-result-button": "View results",
  "causal-assistant-robustness-result-title": "Robustness Evaluation Results",
};

export default assistant;